module.exports = __webpack_public_path__ + "static/img/tab2spic.3f31b104.png";